'use client';

import dynamic from 'next/dynamic';

// 完全禁用 SSR：
// 1. globe.gl 依赖 WebGL，不能在服务端运行
// 2. zustand/persist 在 SSR/hydration 时会产生 mismatch
// 3. Framer Motion 动画需要浏览器环境
const MainScreen = dynamic(() => import('@/components/screens/MainScreen'), {
  ssr: false,
  loading: () => (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ background: '#030712' }}
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-14 h-14 rounded-full border-2 border-t-transparent animate-spin"
          style={{ borderColor: 'rgba(148,180,240,0.4)', borderTopColor: 'rgba(148,180,240,0.9)' }}
        />
        <p className="text-sm font-light tracking-widest" style={{ color: 'rgba(148,180,240,0.6)' }}>
          世界漫游
        </p>
      </div>
    </div>
  ),
});

export default function HomePage() {
  return <MainScreen />;
}
